import { defineComponent as o, h as i, Transition as e } from "vue";
import a from "./ghl-ui.es713.js";
const m = o({
  name: "BaseIconSwitchTransition",
  setup(r, {
    slots: n
  }) {
    const t = a();
    return () => i(e, {
      name: "icon-switch-transition",
      appear: t.value
    }, n);
  }
});
export {
  m as default
};
